import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginService } from '../../features/auth/login.service';

@Injectable({
  providedIn: 'root',
})
export class CardService {
  constructor(private http: HttpClient) {}
  baseUrl: string = environment.baseUrl;

  getAllCardsUser(): Observable<any> {
    return this.http.post(`${this.baseUrl}/card/getcards`, {});
  }

  getAllCards(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/card/getcardsbyadmin`, payload);
  }

  createCard(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/card/createcard`, payload);
  }

  updateCard(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/card/updatecard`, payload);
  }

  deleteCard(id: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/card/deletecard`, { id });
  }
}
